module.exports = __webpack_public_path__ + "img/m_main_logo_color_g.c51606be.png";